import { theme } from "styles/theme";
import styled from "styled-components";

/**
 * Wrapper das ações
 * Layout flexível para posicionar botões à direita.
 */
export const ActionsWrapper = styled.div`
  padding: ${({ theme }) => theme.spacing(2.5)}
    ${({ theme }) => theme.spacing(4)} ${({ theme }) => theme.spacing(3)};
  gap: ${({ theme }) => theme.spacing(1)};
  justify-content: flex-end;
  display: flex;
`;

const ActionButton = styled.button<{
  color: keyof typeof theme.colors.primary | keyof typeof theme.colors.support;
}>`
  padding: ${({ theme }) => theme.spacing(1.25)}
    ${({ theme }) => theme.spacing(2.5)} ${({ theme }) => theme.spacing(0.65)};
  border-radius: ${({ theme }) => theme.spacing(1.5)};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.black};
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  border: none;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    background-color: ${({ theme }) => theme.colors.lightGray};
    cursor: not-allowed;
  }

  /* 👇 Isso aqui faz todos os filhos herdarem o cursor */
  & * {
    cursor: inherit;
  }
`;

/**
 * Botão de cancelar (limpar)
 */
export const CancelButton = styled(ActionButton)`
  background-color: ${({ theme }) => theme.colors.lightRed};
  cursor: pointer;
`;

/**
 * Botão de aplicar (confirmar)
 */
export const ApplyButton = styled(ActionButton)`
  background-color: ${({ theme }) => theme.colors.lightGreen};
  cursor: pointer;
`;
